import React, {createContext, useContext, useMemo} from "react"
import useStoredToggle from "../utils/useStoredToggle"

// Expanded/collapsed state of the left navigation menu.
// Shared between the Header (burger button) and containers/Main/*.js (the drawer itself),
// which are siblings in App.js. Persisted in localStorage; collapsed by default.
const MenuContext = createContext({open: true, toggle: () => {}, setOpen: () => {}})

export function MenuProvider({children}) {
    const [open, toggle, setOpen] = useStoredToggle("hermes.menuOpen", false)
    const value = useMemo(() => ({open, toggle, setOpen}), [open, toggle, setOpen])
    return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>
}

export const useMenu = () => useContext(MenuContext)
